// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import StandardButton from '../../../components/Buttons/Standard';
import usePath from '../usePath';
import { SCENARIOS, PATHS } from '../constants';

import styles from './styles.module.scss';

type Props = {
  scenario?: string,
  phoneNumber: string,
  cobrandedLink?: string,
};

const PageButtons = ({ scenario, phoneNumber, cobrandedLink }: Props) => {
  const getPath = usePath();

  const callSupport = (variant = 'secondary', mobileOnly = true) => (
    <div className={mobileOnly ? styles.callMobile : styles.buttonWrapper}>
      <a href={`tel:${phoneNumber}`}>
        <StandardButton
          isPill
          classes={variant === 'secondary' ? { outlined: styles.customButtonStyle } : undefined}
          extraRootClasses={styles.button}
          variant={variant}
        >
          <FormattedMessage id="app.self-enroll.call-support" />
        </StandardButton>
      </a>
    </div>
  );

  if (scenario === SCENARIOS.IDENTIFY) {
    return (
      <div className={styles.container}>
        <div className={styles.question}>
          <FormattedMessage id="app.self-enroll.still-have-questions" />
        </div>
        <a href={cobrandedLink} className={styles.learnMoreLink}>
          <StandardButton
            isPill
            classes={{ outlined: styles.customButtonStyle }}
            extraRootClasses={styles.button}
            variant="secondary"
          >
            <FormattedMessage id="app.self-enroll.learn-more" />
          </StandardButton>
        </a>
        {callSupport()}
      </div>
    );
  }

  if (scenario === SCENARIOS.ACCOUNT_EXISTS) {
    return (
      <div className={styles.container}>
        <StandardButton
          isPill
          variant="primary"
          onClick={() => {
            window.location = process.env.REACT_APP_ONELINK_URL;
          }}
          extraRootClasses={styles.button}
        >
          <FormattedMessage id="app.self-enroll.found.account-exists.open-app" />
        </StandardButton>
        {callSupport('secondary', false)}
      </div>
    );
  }

  if (scenario === SCENARIOS.COULD_NOT_VERIFY) {
    return (
      <div className={styles.container}>
        <Link to={getPath(PATHS.IDENTIFY)}>
          <StandardButton isPill extraRootClasses={styles.button} variant="primary">
            <FormattedMessage id="app.self-enroll.try-again" />
          </StandardButton>
        </Link>
        {callSupport()}
      </div>
    );
  }

  if (scenario === SCENARIOS.ENROLLMENT_FAILED) {
    return <div className={styles.container}>{callSupport('primary')}</div>;
  }

  return <div className={styles.container}>{callSupport()}</div>;
};

export default PageButtons;
